import { render, staticRenderFns } from "./CarregandoInfo.vue?vue&type=template&id=55230f35&scoped=true&"
import script from "./CarregandoInfo.vue?vue&type=script&lang=js&"
export * from "./CarregandoInfo.vue?vue&type=script&lang=js&"
import style0 from "./CarregandoInfo.vue?vue&type=style&index=0&id=55230f35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55230f35",
  null
  
)

export default component.exports